import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigServerService } from 'app/core';
import { IUsuarioFilter } from '../interface/usuario-filter.interface';
import { Observable } from 'rxjs';
import { IUsuarioSearchAsyncResponse } from '../interface/usuario.interface';
import { buildHttpParams } from 'app/core/utils/http-util';

@Injectable({
  providedIn: 'root',
})
export class UsuarioApi {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private configServerService: ConfigServerService
  ) {
    this.apiUrl = `${this.configServerService.getPathApi()}/usuario`;
  }

  getUsuarios(filter: IUsuarioFilter): Observable<IUsuarioSearchAsyncResponse> {
    const params = buildHttpParams(filter);

    return this.http.get<IUsuarioSearchAsyncResponse>(`${this.apiUrl}`, {
      params,
    });
  }
}
